/**
 * QA RESULT PANEL — the "what just happened" moment (the #1 comprehension fix).
 *
 * When QA returns, this durable panel appears where there used to be a collapsed <details>. It
 * renders strings the machine already computed and the old UI hid: the headline verdict, the
 * one-line state, and a delta of what QA actually did — plus a plain sentence on what QA even IS.
 * Open by default, never a toast, never re-collapsed.
 */
export function QaResultPanel({
  headline,
  subhead,
  checksRan,
  checksTotal,
  passed,
  advisories,
  reviewers,
  state
}: {
  headline: string;
  subhead: string;
  checksRan: number;
  checksTotal: number;
  passed: number;
  advisories: number;
  reviewers: number;
  state: "passed" | "blocked" | "recorded";
}) {
  const delta = [
    `${checksRan} of ${checksTotal} checks ran`,
    `${passed} passed`,
    `${advisories} advisor${advisories === 1 ? "y" : "ies"} opened`,
    `${reviewers} reviewer${reviewers === 1 ? "" : "s"} weighed in`
  ];
  return (
    <section className="qa-result" data-state={state} data-testid="qa-result" aria-live="polite">
      <p className="qa-result-kicker">Final QA just ran — here's what happened</p>
      <h2 className="qa-result-headline">{headline}</h2>
      {subhead ? <p className="qa-result-subhead">{subhead}</p> : null}
      <ul className="qa-result-delta">
        {delta.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
      <p className="qa-result-what">
        <strong>What QA is:</strong> six deterministic checks plus a five-lens advisory review. It verifies the
        protected facts survive verbatim, the edited blocks stay in budget, every kept edit is backed by real
        sources, patches place correctly, the pages still render without overflow, and reviewers weigh in — then it
        builds the export package.
      </p>
    </section>
  );
}
